import styled from "styled-components";
import MainButton from "./MainButton.styled";

const GreenButton = styled(MainButton)`
    background: ${(p) => p.theme.colors.green};
    border: 1px solid ${(p) => p.theme.colors.green};
    border-radius: 3px;
    color: ${(p) => p.theme.colors.white};
    height: 76px;
    margin: 0;
    transition: all 300ms ease-in-out;
    &:hover {
        background-color: #0D4910;
        border-color: #0D4910;
        box-shadow: none;
    }
    @media screen and (min-width: 768px) {
        margin: 0;
    }
`;

export default GreenButton;
